import { render } from "./OnlineCare.vue?vue&type=template&id=24a9b110&scoped=true&ts=true"
import script from "./OnlineCare.vue?vue&type=script&lang=ts"
export * from "./OnlineCare.vue?vue&type=script&lang=ts"

import "./OnlineCare.vue?vue&type=style&index=0&id=24a9b110&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9b110"]])

export default __exports__